/**
 * How a space's day and times read, shared by the API's spaces and the
 * demo's (`demo/demo-spaces.ts`). No imports beyond the clock, so the demo
 * store can use it without a cycle.
 */

import { clock } from '../visits/visit-detail-panel/admission';

/** "09:00–17:00", or "All day" when the booking spans the day. */
export function spaceTimes(start: string, end: string): string {
  const s = new Date(start);
  const e = new Date(end);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return '';
  if (e.getTime() - s.getTime() >= 23 * 3600_000) {
    return $localize`:@@visitors-space-all-day:All day`;
  }
  return `${clock(start)}–${clock(end)}`;
}

/** "Thu 16 Jul", the day a space is held. */
export function spaceDay(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
}
